import React from 'react';

/** Affiche en gras les passages entourés de **doubles astérisques** */
export function renderEmphasis(text: string) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => part.startsWith('**') && part.endsWith('**') ? <strong key={i} className="font-semibold text-blue-reways-950-lock" data-id="element-254" data-mp="2gw82zshjs5nc">
        {part.slice(2, -2)}
      </strong> : <React.Fragment key={i} data-id="element-255" data-mp="2lrf20mzvgm5x">{part}</React.Fragment>);
}